import React from 'react'
import parse from 'html-react-parser'
import classes from './styles.module.css'

const Tag = ({text, slug}: {text: string; slug: string}) => {
  return <span className={`${classes.tag} ${classes[slug]}`}>{parse(text)}</span>
}

export default Tag
